<template>
    <common-yes-no-modal
        v-if="isModalOpen"
        :showWarningIcon="true"
        height="tiny"
        :headingText="modalHeading()"
        :noButtonText="$t('common.microcopy.close')"
        :yesButtonText="$t('common.microcopy.go_to_profile')"
        @close="closeModal()"
        @continue="redirectToUserProfile"
    ></common-yes-no-modal>
</template>

<script>
    import RoutesEnum from 'enums/routes.enum'

    export default {
        props: {
            isModalOpen: { type: Boolean, default: false },
        },

        methods: {
            redirectToUserProfile() {
                const query = {}
                if (this.$auth.areFirstAndLastNameCompleted()) {
                    query.tab = 'personalDetails'
                } else {
                    query.tab = 'profile'
                }
                this.$router.push({ name: RoutesEnum.USER.ME, params: { tabType: query.tab }, query })
                this.closeModal()
            },

            closeModal() {
                this.emitEvent({ name: 'close-complete-profile-modal' })
            },

            modalHeading() {
                if (!this.$auth.areFirstAndLastNameCompleted()) {
                    return this.$t('modals.complete_profile_modal.complete_first_and_last_name')
                } else if (!this.$auth.isMobileCompleted()) {
                    return this.$t('modals.complete_profile_modal.complete_mobile_phone')
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .my-companies__message {
        width: max-content;
    }
</style>
